<template>
    <b-modal
        id="combined-evaluate-student-modal"
        v-model="modal"
        modal-class="apprentice-default-modal"
        size="lg"
        title="Leerlingbespreking"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        @ok="onOk">
        <div class="student-evaluation">
            <div class="personal-goals-overview">
                <h4 class="title">Leerdoelen</h4>
                <ul class="personal-goals">
                    <li
                        class="personal-goal"
                        v-for="personalGoal of personalGoals">
                        {{ personalGoal.name }}
                    </li>
                </ul>
            </div>

            <div class="evaluate">
                <h4 class="title">{{ moment(new Date()).format('D MMM YYYY') }}</h4>

                <div class="educational">
                    <h6 class="title">Didactisch</h6>
                    <ckeditor
                        v-model="educationalText"
                        :editor="editor"
                        :config="editorConfig"
                        wrap>
                    </ckeditor>
                </div>

                <div class="pedagogical">
                    <h6 class="title">Pedagogisch</h6>
                    <ckeditor
                        v-model="pedagogicalText"
                        :editor="editor"
                        :config="editorConfig"
                        wrap>
                    </ckeditor>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../helpers/ApprenticeEditor';
import moment from 'moment';

export default {
    name: 'design-2021-combined-evaluate-student-modal-component',
    props: {
        personalGoalsIn: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            educationalText: '',
            pedagogicalText: '',
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'evaluation-editor-content',
                bodyClass: 'evaluation-editor-body',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        'alignment',
                        '|',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
            },
            modal: false,
        };
    },

    methods: {
        onOk() {
            let data = {
                educational_text: this.educationalText,
                pedagogical_text: this.pedagogicalText,
            };

            this.$emit('store-student-evaluation', data);
        },

        show() {
            this.modal = true;
        },
    },

    computed: {
        personalGoals() {
            if (!this.personalGoalsIn.length) {
                return [];
            }

            return this.personalGoalsIn.filter((personalGoal) => !personalGoal.archived);
        },
    },
};
</script>

<style scoped lang="scss">
.personal-goals-overview,
.date-select {
    margin-bottom: $grid-gutter-width;
}

.personal-goals {
    padding-left: $grid-gutter-width;
}

.date-select {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    select {
        width: 100%;
        margin-bottom: 0;
    }
}

.evaluate {
    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }
}

.educational,
.pedagogical {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');

    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'eight');
    }

    ::v-deep .ck-editor.ck-editor {
        .ck-editor__main {
            > .ck-editor__editable {
                border-top-right-radius: 0;
                border-top-left-radius: 0;
                border-top: 1px solid $border-color;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .date-select {
        select {
            width: 150px;
        }
    }
}
</style>
